import { Component, OnInit, OnDestroy } from "@angular/core";
import { MuestraService } from '../../servicios/muestra-servicios';
import { LogService } from "../../servicios/log-servicios";
import { takeUntil } from "rxjs/operators";
import { Subject, Subscription } from "rxjs";
import { CoordCampo } from '../../interfaces/varias-interfaces';


@Component({
  selector: 'app-dropdown-elem',
  templateUrl: './dropdown-elem.component.html',
  styleUrls: ['./dropdown-elem.component.css']
})
export class DropdownElemComponent implements OnInit, OnDestroy {
  private _onDestroy$: Subject<void> = new Subject();

  muestraDropdownSub: Subscription;
  muestraDropdown: boolean = false;
  ddPlaceholder: string;
  ddOpciones: string[] = [''];
  ddHabilitar: string[] = ['SI'];
  ddDatosCampo: CoordCampo = { left: '', top: '', width: '', height: '' };
  ddClase: string;
  ddRespuesta: string = '';

  cantItems: number = 0;
  dropdownStyle: object;
  lineaDropdownStyle: object;

  ddContenedor: HTMLElement;
  ddInput: HTMLInputElement;
  ddDatalist: HTMLDataListElement;
  currentFocus: number = -1;
  //array itemsFiltrados solo se usan en ddInputOnKeydown
  //Antes de crear array itemsFiltrados (usando solo currentFocus) cuando la lista de opciones está filtrada 
  //y se mueve con flechas, en algunos movimientos se pasa por elementos no visibles, lo que hace que 
  //en pantalla se vea como si no se hubiera presionado la tecla y si se da Enter, se elige una opción no visible!
  //itemsFiltrados tiene una lista de las opciones válidas, itemFiltradoActivo indica la posición actual en el array
  itemsFiltrados: number[];   //aquí se guarda una lista de los items que siguen siendo visibles en el dropdown
  itemFiltradoActivo: number; //índice actual en itemsFiltrados

  constructor(
    private muestraService: MuestraService,
    private logService: LogService
  ) { }

  ngOnInit() {
    this.logService.consoleLog('2', 'CE DD init');

    this.muestraDropdownSub = this.muestraService.dropdown$
      .pipe(takeUntil(this._onDestroy$))
      .subscribe(p => {
        this.muestraDropdown = p;
        if (this.muestraDropdown) {
          //leo los paráms para mostrar en el html
          this.logService.consoleLog('2', 'CE DD mDd muestraDropdown true');
          this.ddPlaceholder = this.muestraService.ddPlaceholder;
          this.ddOpciones = this.muestraService.ddOpciones;
          this.ddHabilitar = this.muestraService.ddHabilitar;
          this.ddDatosCampo = this.muestraService.ddDatosCampo;
          this.ddClase = this.muestraService.ddClase;

          this.itemsFiltrados = [];
          for (let i = 0; i < this.ddOpciones.length; i++) {
            this.itemsFiltrados.push(i);
          }
          this.logService.consoleLog('2', 'CE DD mDd Opc: ' + this.ddOpciones[1]);
          this.logService.consoleLog('2', 'CE DD mDd place: ' + this.ddPlaceholder);
          this.ddInput = <HTMLInputElement>document.getElementById('ddInput');
          this.ddDatalist = <HTMLDataListElement>document.getElementById('ddDatalist');
          this.ddInput.style.display = "none";
          this.ddDatalist.style.display = "none";
          this.ddRespuesta = '';
          setTimeout(() => {
            this.ddInput = <HTMLInputElement>document.getElementById('ddInput');
            this.ddDatalist = <HTMLDataListElement>document.getElementById('ddDatalist');
            this.ddContenedor = <HTMLElement>document.getElementById('contenedor');
            this.ddContenedor.style.left = this.ddDatosCampo.left;
            this.ddContenedor.style.top = this.ddDatosCampo.top;
            this.ddContenedor.style.width = this.ddDatosCampo.width;
            this.ddContenedor.style.height = this.ddDatosCampo.height;
            this.logService.consoleLog('2', 'CE DD mDd Clase: ' + this.ddClase);
            //this.ddInput.style.width =  this.ddDatosCampo.width;
            //this.ddInput.className = this.ddClase;
            this.llenarDropdown();
            //this.ddInput.setAttribute('value', this.ddPlaceholder);
            this.currentFocus = this.encontrarActual(this.ddPlaceholder);
            this.itemFiltradoActivo = this.currentFocus;  //al iniciar no está aplicado ningún filtro, currentFocus coincide con itemFiltradoActivo
            this.addActive(this.ddDatalist.options);
            this.ddInput.style.display = "block";
            this.ddInput.style.width = (parseFloat(this.ddDatosCampo.width.slice(0, -2)) - 1).toString() + 'px';
            this.ddDatalist.style.display = "block";
            this.ddContenedor.style.display = "block";
            this.ddInput.focus();   //para que apenas se abre el dropdown se pueda escribir o mover las flechas
          }, 100);
        } else {
          //nada
          this.logService.consoleLog('2', 'CE DD mDd Sub false');
        }
      })
  }

  ngOnDestroy() {
    //Esta técnica de this._onDestroy$ en ngOnDestroy
    //permite liberar todos los Observables que tengan un .takeUntil(this._onDestroy$)
    //Si un Observable tiene take(n) no requiere destruirse porque ya lo hace luego de leer n veces
    this.logService.consoleLog('2', 'CE DD cerrando dropdown-elem.component');
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }

  public emitirRespuesta(resp: number) {
    this.muestraService.ocultaDropdown(resp, '.')
  }

  public baseOnClick() {
    //este evento se produce siempre que se da clic, incluso cuando es en el input o el datalist.
    //quiero que el clic fuera del input y el datalist se demore un poco, para que primero llegue al servicio el evento válido
    //Si es en el datalist, llega la respuesta a quien lanzó el dropdown y lo cierra, el segundo mensaje no importa.
    //pero si es en el input, quiero que no haga nada, que no dé respuesta ni cierre. Entonces mando al servicio un mensaje especial que llega primero
    //y le digo al servicio que si el siguiente mensaje es un 'dropdown cerrado...' no le haga caso.
    setTimeout(() => {
      this.logService.consoleLog('2', 'CE DD baseOnClick');
      this.muestraService.ocultaDropdown(999, 'Dropdown cerrado con Esc o clic afuera');
    }, 100);
  }

  public inputOnClick() {
    //mando al servicio un mensaje especial que llega antes que el 'Dropdown cerrado...' 
    //y le digo al servicio que si el siguiente mensaje es un 'Dropdown cerrado...' no le haga caso.
    this.logService.consoleLog('2', 'CE DD inputOnClick no leer próx');
    this.muestraService.ocultaDropdown(999, 'Clic en input, no leer próximo mensaje Dropdown cerrado');
  }

  public ddInputOnFocus() {
    this.logService.consoleLog('2', "CE DD onfocus");
    //OJO COMENTE LAS PROX 2 LINEAS PORQUE PARECEN INNECESARIAS, PROBAR!!!!
    //this.llenarDropdown();
    //this.ddDatalist.style.display = "block";
    ////this.ddInput.style.borderRadius = "5px 5px 0 0";
  }

  public ddInputOnInput() {
    this.logService.consoleLog('2', "CE DD oninput");
    this.itemsFiltrados = [];
    this.currentFocus = -1;
    this.itemFiltradoActivo = -1;
    //var text = this.ddInput.value.toUpperCase();
    //for (let optionSeq in this.ddDatalist.options) {   //let option of this.ddDatalist.options
    for (let i = 0; i < this.ddDatalist.options.length; i++) {
      //let num = Number(optionSeq);
      //if (optionSeq == '0' || Number.isInteger(num)) {
      const option = this.ddDatalist.options.item(i);
      this.logService.consoleLog('2', 'CE DD option.value.toUpperCase()');
      this.logService.consoleLog('2', 'CE DD ' + option.value.toUpperCase());
    }
  }

  public ddInputOnKeydown(e) {
    this.logService.consoleLog('2', 'CE DD ' + e.keyCode);
    if (e.keyCode == 40) {
      this.itemFiltradoActivo++;
      this.currentFocus = this.itemsFiltrados[this.itemFiltradoActivo];
      this.addActive(this.ddDatalist.options);
    } else if (e.keyCode == 38) {
      this.itemFiltradoActivo--;
      this.currentFocus = this.itemsFiltrados[this.itemFiltradoActivo];
      this.addActive(this.ddDatalist.options);
    } else if (e.keyCode == 13) {
      e.preventDefault();
      if (this.currentFocus > -1) {
        /*and simulate a click on the "active" item:*/
        if (this.ddDatalist.options) this.ddDatalist.options[this.currentFocus].click();
      }
    } else if (e.keyCode == 27) {
      this.muestraService.ocultaDropdown(999, 'Dropdown cerrado con Esc o clic afuera');
    }
  }

  private llenarDropdown() {
    this.logService.consoleLog('2', "CE DD llenar, this.ddDatalist.options.length:" + this.ddDatalist.options.length);
    this.logService.consoleLog('2', 'CE DD ' + this.ddDatalist.options[0].value);
    this.logService.consoleLog('2', 'CE DD ' + this.ddDatalist.options.length.toString());
    //for...in devuelve la clave, for...of  devuelve el valor, esto es más directo pero requiere que el objeto tenga un "iterator", por eso uso for...in.
    //for (let optionSeq in this.ddDatalist.options) {   //let option of this.ddDatalist.options
    for (let index = 0; index < this.ddDatalist.options.length; index++) {
      this.logService.consoleLog('2', "CE DD index: " + index);
      //let num = Number(optionSeq);
      //if (optionSeq == '0' || Number.isInteger(num)) {
      const option = this.ddDatalist.options.item(index);
      //this.logService.consoleLog('2',"CE DD option: ");
      //this.logService.consoleLog('2','CE DD ' + option);
      option.style.display = "block";
      //si no uso el estilo arrow function (=>) pierde el contexto y this ya no encuentra ddInput ni ddDatalist 
      option.onclick = () => {
        //this.ddInput.value = option.value;
        this.ddDatalist.style.display = "none";
        //this.ddInput.style.borderRadius = "5px";
      };
      //}
    }
  }

  private encontrarActual(texto): number {
    let seq: number = 0;
    this.logService.consoleLog('2', 'CE DD texto');
    this.logService.consoleLog('2', 'CE DD ' + texto);
    for (let index = 0; index < this.ddDatalist.options.length; index++) {
      const option = this.ddDatalist.options.item(index);
      this.logService.consoleLog('2', 'CE DD option.value.toUpperCase()');
      this.logService.consoleLog('2', 'CE DD ' + option.value.toUpperCase());
      if (option.value.toUpperCase() == texto.toUpperCase()) {
        seq = index;
        index = this.ddDatalist.options.length;
      }
    }
    return seq;
  }

  private addActive(x) {
    //this.logService.consoleLog('2','CE DD x');
    //this.logService.consoleLog('2',x);
    if (!x) return false;
    this.removeActive(x);
    if (this.itemFiltradoActivo >= this.itemsFiltrados.length) {
      this.itemFiltradoActivo = 0;
      this.currentFocus = this.itemsFiltrados[this.itemFiltradoActivo];
    }
    if (this.itemFiltradoActivo < 0) {
      this.itemFiltradoActivo = this.itemsFiltrados.length - 1;
      this.currentFocus = this.itemsFiltrados[this.itemFiltradoActivo];
    }
    x[this.currentFocus].classList.add("active");
  }

  private removeActive(x) {
    for (let i = 0; i < x.length; i++) {
      x[i].classList.remove("active");
    }
  }

  public asignaEstiloOcultar(i: number): object {
    let o = {};
    if (this.ddHabilitar[i] == 'NO') {
      o = { "background-color": "rgb(236, 250, 250, 0.96)", "color": "gray" };
    }
    return o;
  }

}
